module.exports = __webpack_public_path__ + "1_0_59/img/fresh.2e608340.jpg";